import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import "jspdf-autotable";

import config from "../../../envconfig";
import { UserContext } from "../../common/UserContext";
import { useNavigate } from "react-router-dom";

function ShipInScanByProduct() {
  const {
    UM_UserId,
    UM_GroupId,
    UM_UserCode,
    UM_CompanyID,
    selectedScpId,
    UM_DefaultSCPId,
    UM_CompanyGrpID,
  } = useContext(UserContext);
  const { SHPH_ShipmentID } = useParams();
  const navigate = useNavigate();
  const [shipmentDetails, setShipmentDetails] = useState({
    SHPH_ShipmentCode: "",
    dcl_scpto: selectedScpId,
    SHPH_ShipmentDate: "",
    LGCM_Name: "",
    LGCVM_VehicleNumber: "",
    dcl_InvoiceNumber: "",
  });

  const [TableData, setTableData] = useState([]);
  const [RSN, setRSN] = useState("");
  const [SelectedShipmentID, setSelectedShipmentID] = useState(null);
  const [UniqueRSN, setUniqueRSN] = useState(new Set());
  const [ExtractedGTIN, setExtractedGTIN] = useState(null);
  const [ScannedResultForProduct, setScannedResultForProduct] = useState("");
  const [shipRandomrsn, setShipRandomrsn] = useState({ getparentrsn: "" });
  const [fetchedData, setFetchedData] = useState("");
  const [notAddedValues, setNotAddedValues] = useState([]);
  const [CheckedItems, setCheckedItems] = useState(new Set());
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [inputMode, setInputMode] = useState("scan"); // "scan" or "manual"
  const inputRef = useRef(null); // Add useRef to reference the input element
  const debounceTimer = useRef(null);
  const [manualInputEnabled, setManualInputEnabled] = useState(false);
  const [isRSNScanned, setIsRSNScanned] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    sessionStorage.setItem("UM_GroupId", UM_GroupId);
    sessionStorage.setItem("UM_CompanyGrpID", UM_CompanyGrpID);
    sessionStorage.setItem("UM_DefaultSCPId", UM_DefaultSCPId);
    sessionStorage.setItem("UM_CompanyID", UM_CompanyID);
    sessionStorage.setItem("UM_UserId", UM_UserId);
    sessionStorage.setItem("UM_UserCode", UM_UserCode);
    sessionStorage.setItem("selectedScpId", selectedScpId);
  }, [
    UM_GroupId,
    UM_CompanyGrpID,
    UM_DefaultSCPId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    selectedScpId,
  ]);

  const [rsnTree, setRsnTree] = useState(null);
  const [expandedNodes, setExpandedNodes] = useState(new Set());

const renderRSNNode = (node, level = 0, isRoot = false, insideBox = false) => {
  const hasChildren = node.children && node.children.length > 0;
  const isExpanded = expandedNodes.has(node.IRS_RandomNo);

  return (
    <div key={node.IRS_RandomNo} style={{ marginLeft: level * 20 }}>
      {/* Root Node */}
      {isRoot ? (
        <>
          <input
            className="form-check-input"
            type="checkbox"
            checked={CheckedItems.has(node.IRS_RandomNo)}
            onChange={(e) => handleCheckBoxChange(e, node.IRS_RandomNo)}
            value={node.IRS_RandomNo}
            id={`check-${node.IRS_RandomNo}`}
          />
          <label
            className="form-check-label"
            htmlFor={`check-${node.IRS_RandomNo}`}
            style={{ color: "#465a64", marginLeft: "6px" }}
          >
            {node.IRS_RandomNo}
          </label>

          {/* Expand/Collapse button for root */}
          {hasChildren && (
            <button
              type="button"
              className="btn btn-link btn-sm"
              style={{ fontSize: "12px", padding: "2px 6px", marginLeft: "6px" }}
              onClick={() => {
                const newExpanded = new Set(expandedNodes);
                if (isExpanded) newExpanded.delete(node.IRS_RandomNo);
                else newExpanded.add(node.IRS_RandomNo);
                setExpandedNodes(newExpanded);
              }}
            >
              {isExpanded ? "➖" : "➕"}
            </button>
          )}
        </>
      ) : (
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* Always reserve space for expand/collapse if inside box */}
          {insideBox && (
            <div style={{ width: "18px", textAlign: "center" }}>
              {hasChildren ? (
                <button
                  type="button"
                  className="btn btn-link btn-sm"
                  style={{
                    fontSize: "12px",
                    padding: "1px 3px",
                    lineHeight: "1",
                  }}
                  onClick={() => {
                    const newExpanded = new Set(expandedNodes);
                    if (isExpanded) newExpanded.delete(node.IRS_RandomNo);
                    else newExpanded.add(node.IRS_RandomNo);
                    setExpandedNodes(newExpanded);
                  }}
                >
                  {isExpanded ? "➖" : "➕"}
                </button>
              ) : (
                <span style={{ display: "inline-block", width: "12px" }} />
              )}
            </div>
          )}

          {/* Label */}
          <span style={{ color: "#465a64", marginLeft: "6px" }}>
            {node.IRS_RandomNo}
          </span>
        </div>
      )}

      {/* Children */}
      {hasChildren && isExpanded && (
        <div
          style={{
            marginTop: 6,
            border: isRoot ? "1px solid #ccc" : "none",
            borderRadius: isRoot ? "6px" : "0",
            padding: isRoot ? "10px" : "0",
          }}
        >
          {node.children.map((child) =>
            renderRSNNode(child, level + 1, child.isRoot, true) // insideBox = true
          )}
        </div>
      )}
    </div>
  );
};

  // ========================== Log File ===============================
  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "Shipment Inward Scanning By Product :",
          action,
          userCode: UM_UserCode,
          isError,
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };
  //====================================================================
  //============================================
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [confirmationCallback, setConfirmationCallback] = useState(null);
  const [cancelCallback, setCancelCallback] = useState(null); // Cancel callback for "NO"

  const showPopup = (message, onConfirm, onCancel) => {
    setMessage(message);
    setConfirmationCallback(() => onConfirm);
    setCancelCallback(() => onCancel); // Assign cancel callback
    setPopupVisible(true);
  };

  const handlePopupConfirm = () => {
    if (confirmationCallback) confirmationCallback();
    setPopupVisible(false);
  };

  const handlePopupClose = () => {
    if (cancelCallback) cancelCallback(); // Run cancel callback if "NO" is clicked
    setPopupVisible(false);
  };

  //============================================
  const FetchProductData = async (rsnValue, shipment) => {
    try {
      if (!shipRandomrsn.getparentrsn) {
        console.error("shipRandomrsn.getparentrsn is undefined");
        return;
      }
      if  (!ExtractedGTIN) {
        const RSNStatus = await fetch(
        `${config.API_URL}/RSN_Status_Inward_Product_Wise_NonGTIN/${SHPH_ShipmentID}/${shipRandomrsn.getparentrsn}`
      );
      if (RSNStatus.ok) {
        const data = await RSNStatus.json();
        console.log("Fetched Data:", data);
        //================================================================================
        if (data.IRS_Status === 22) {
          const RES = await fetch(
            `${config.API_URL}/ChildRSN_Lock_Inward/${data.IRS_RandomNo}`
          );
          if (RES.ok) {
            const data = await RES.json();
            console.log("Fetched Data:", data);
          } else {
            console.error("Error fetching the data");
          }
          const response = await fetch(
            `${config.API_URL}/ParentRSN_PackSize_Inward/${data.IRS_RandomNo}`
          );
          if (response.ok) {
            const data = await response.json();
            console.log("Fetched Data from ParentRSN_PackSize:", data);
            setFetchedData(data.PL_ProductCode);
            if (data.IRS_ParentRandomNo) {
              showPopup(
                "Are you sure you want to disaggregate the Parent RSN ?",
                async () => {
                  try {
                    const packSizeResponse = await fetch(
                      `${config.API_URL}/ParentRSN_Disaggregation_Inward/${data.IRS_RandomNo}`
                    );
                    if (packSizeResponse.ok) {
                      const packSizeData = await packSizeResponse.json();
                      console.log(
                        "Fetched Data from ParentRSN_Disaggregation:",
                        packSizeData
                      );

                      //=======================//===================//===============//
                      const ParentRSNLockResponseChild = await axios.get(
                        `${config.API_URL}/ChildRSNLock_InwardDisaggregation/${shipRandomrsn.getparentrsn}/${SHPH_ShipmentID}/${selectedScpId}`
                      );
                      if (ParentRSNLockResponseChild.status === 200) {
                        console.log("Child RSN Sussfully Updated");
                      } else {
                        console.log("Child RSN Not Updated");
                      }
                      const ParentRSNLockResponse = await axios.get(
                        `${config.API_URL}/ParentRSN_Lock_Update_Inward/${shipRandomrsn.getparentrsn}/${SHPH_ShipmentID}/${selectedScpId}`
                      );
                      if (ParentRSNLockResponse.status === 200) {
                        const packSizeData = ParentRSNLockResponse.data;
                        console.log(
                          "Fetched Data from ParentRSN_Disaggregation:",
                          packSizeData
                        );
                        const parentRSNResponse = await fetch(
                          `${config.API_URL}/Disaggrigated_RSN_History_Inward`,
                          {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                              IRS_RandomNo: data.IRS_RandomNo,
                            }),
                          }
                        );
                        const parentRSNData = await parentRSNResponse.json();
                        if (
                          parentRSNResponse.ok &&
                          parentRSNData.IRS_ParentRandomNo
                        ) {
                          const parentRandomNo =
                            parentRSNData.IRS_ParentRandomNo;
                          logAction(
                            `The Parent RSN : ${parentRandomNo.join(
                              ", "
                            )} of RSN ${
                              data.IRS_RandomNo
                            } of Shipment ID : ${SHPH_ShipmentID} Disaggregated Successfully`
                          );
                        }

                        console.log(
                          "ShipmentID",
                          SHPH_ShipmentID,
                          "SHPD SCP ID",
                          selectedScpId
                        );
                      } else {
                        console.error("Error fetching IRS_PackSize data");
                      }
                      // //=======================//===================//===============//
                      setFetchedData(
                        packSizeData.IRS_PackSize,
                        packSizeData.PL_ProductCode
                      );
                      setShipRandomrsn(packSizeData);
                      HandleAddRSNForBox(
                        packSizeData.IRS_PackSize,
                        packSizeData.PL_ProductCode
                      );
                    } else {
                      console.error("Error fetching IRS_PackSize data");
                    }
                  } catch (error) {
                    console.error("Error fetching IRS_PackSize data:", error);
                  }
                },
                async () => {
                  try {
                    const response = await axios.put(
                      `${config.API_URL}/Re_Update_Scanned_IRS_Status_Inward/${ScannedResultForProduct}`
                    );
                    if (response.status === 200) {
                      console.log(
                        `IRS_Status updated successfully for value '${ScannedResultForProduct}'`
                      );
                    } else {
                      console.error(
                        `Failed to update IRS_Status for value '${ScannedResultForProduct}'`
                      );
                    }
                  } catch (error) {
                    console.error("Error updating IRS_Status:", error);
                  }
                  setFetchedData("");
                  setScannedResultForProduct("");
                }
              );
            } else {
              console.log("Setting IRS_PackSize directly:", data.IRS_PackSize);
              setFetchedData(data.IRS_PackSize);
              setShipRandomrsn(data);
              HandleAddRSNForBox(data.IRS_PackSize, data.PL_ProductCode);
            }
          } else {
            console.error("Error fetching the data");
          }
        } else if (data.IRS_Status === 21) {
          if (!isRSNScanned) {
            toast.warning("Invalid RSN");
            return;
          } else {
            console.log("RSN scanned");
          }
        } else if (data.IRS_Status === 6) {
          if (!isRSNScanned) {
            toast.warning("RSN already scanned");
            logAction(`RSN  ${data.IRS_RandomNo} RSN already scanned`);
            setScannedResultForProduct("");
            return;
          } else {
            console.log("RSN Scanned");
          }
        }
      } else if (RSNStatus.status === 404) {
        if (!isRSNScanned) {
          toast.warning("Invalid RSN");
        } else {
          console.log("RSN scanned");
        }
        console.error("Error fetching the data");
        setScannedResultForProduct("");
      } else {
        setScannedResultForProduct("");
        console.error("Error fetching the RSN Status");
      }
      } else {
        const RSNStatus = await fetch(
        `${config.API_URL}/RSN_Status_Inward_Product_Wise/${SHPH_ShipmentID}/${shipRandomrsn.getparentrsn}/${ExtractedGTIN}`
      );
      if (RSNStatus.ok) {
        const data = await RSNStatus.json();
        console.log("Fetched Data:", data);
        //================================================================================
        if (data.IRS_Status === 22) {
          const RES = await fetch(
            `${config.API_URL}/ChildRSN_Lock_Inward/${data.IRS_RandomNo}`
          );
          if (RES.ok) {
            const data = await RES.json();
            console.log("Fetched Data:", data);
          } else {
            console.error("Error fetching the data");
          }
          const response = await fetch(
            `${config.API_URL}/ParentRSN_PackSize_Inward/${data.IRS_RandomNo}`
          );
          if (response.ok) {
            const data = await response.json();
            console.log("Fetched Data from ParentRSN_PackSize:", data);
            setFetchedData(data.PL_ProductCode);
            if (data.IRS_ParentRandomNo) {
              showPopup(
                "Are you sure you want to disaggregate the Parent RSN ?",
                async () => {
                  try {
                    const packSizeResponse = await fetch(
                      `${config.API_URL}/ParentRSN_Disaggregation_Inward/${data.IRS_RandomNo}`
                    );
                    if (packSizeResponse.ok) {
                      const packSizeData = await packSizeResponse.json();
                      console.log(
                        "Fetched Data from ParentRSN_Disaggregation:",
                        packSizeData
                      );

                      //=======================//===================//===============//
                      const ParentRSNLockResponseChild = await axios.get(
                        `${config.API_URL}/ChildRSNLock_InwardDisaggregation/${shipRandomrsn.getparentrsn}/${SHPH_ShipmentID}/${selectedScpId}`
                      );
                      if (ParentRSNLockResponseChild.status === 200) {
                        console.log("Child RSN Sussfully Updated");
                      } else {
                        console.log("Child RSN Not Updated");
                      }
                      const ParentRSNLockResponse = await axios.get(
                        `${config.API_URL}/ParentRSN_Lock_Update_Inward/${shipRandomrsn.getparentrsn}/${SHPH_ShipmentID}/${selectedScpId}`
                      );
                      if (ParentRSNLockResponse.status === 200) {
                        const packSizeData = ParentRSNLockResponse.data;
                        console.log(
                          "Fetched Data from ParentRSN_Disaggregation:",
                          packSizeData
                        );
                        const parentRSNResponse = await fetch(
                          `${config.API_URL}/Disaggrigated_RSN_History_Inward`,
                          {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                              IRS_RandomNo: data.IRS_RandomNo,
                            }),
                          }
                        );
                        const parentRSNData = await parentRSNResponse.json();
                        if (
                          parentRSNResponse.ok &&
                          parentRSNData.IRS_ParentRandomNo
                        ) {
                          const parentRandomNo =
                            parentRSNData.IRS_ParentRandomNo;
                          logAction(
                            `The Parent RSN : ${parentRandomNo.join(
                              ", "
                            )} of RSN ${
                              data.IRS_RandomNo
                            } of Shipment ID : ${SHPH_ShipmentID} Disaggregated Successfully`
                          );
                        }

                        console.log(
                          "ShipmentID",
                          SHPH_ShipmentID,
                          "SHPD SCP ID",
                          selectedScpId
                        );
                      } else {
                        console.error("Error fetching IRS_PackSize data");
                      }
                      // //=======================//===================//===============//
                      setFetchedData(
                        packSizeData.IRS_PackSize,
                        packSizeData.PL_ProductCode
                      );
                      setShipRandomrsn(packSizeData);
                      HandleAddRSNForBox(
                        packSizeData.IRS_PackSize,
                        packSizeData.PL_ProductCode
                      );
                    } else {
                      console.error("Error fetching IRS_PackSize data");
                    }
                  } catch (error) {
                    console.error("Error fetching IRS_PackSize data:", error);
                  }
                },
                async () => {
                  try {
                    const response = await axios.put(
                      `${config.API_URL}/Re_Update_Scanned_IRS_Status_Inward/${ScannedResultForProduct}`
                    );
                    if (response.status === 200) {
                      console.log(
                        `IRS_Status updated successfully for value '${ScannedResultForProduct}'`
                      );
                    } else {
                      console.error(
                        `Failed to update IRS_Status for value '${ScannedResultForProduct}'`
                      );
                    }
                  } catch (error) {
                    console.error("Error updating IRS_Status:", error);
                  }
                  setFetchedData("");
                  setScannedResultForProduct("");
                }
              );
            } else {
              console.log("Setting IRS_PackSize directly:", data.IRS_PackSize);
              setFetchedData(data.IRS_PackSize);
              setShipRandomrsn(data);
              HandleAddRSNForBox(data.IRS_PackSize, data.PL_ProductCode);
            }
          } else {
            console.error("Error fetching the data");
          }
        } else if (data.IRS_Status === 21) {
          if (!isRSNScanned) {
            toast.warning("Invalid RSN");
            return;
          } else {
            console.log("RSN scanned");
          }
        } else if (data.IRS_Status === 6) {
          if (!isRSNScanned) {
            toast.warning("RSN already scanned");
            logAction(`RSN  ${data.IRS_RandomNo} RSN already scanned`);
            setScannedResultForProduct("");
            return;
          } else {
            console.log("RSN Scanned");
          }
        }
      } else if (RSNStatus.status === 404) {
        if (!isRSNScanned) {
          toast.warning("Invalid RSN");
        } else {
          console.log("RSN scanned");
        }
        console.error("Error fetching the data");
        setScannedResultForProduct("");
      } else {
        setScannedResultForProduct("");
        console.error("Error fetching the RSN Status");
      }
      }
      
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleInputModeChange = (mode) => {
    setInputMode(mode);
    setManualInputEnabled(mode === "manual" || mode === "scan");
    setScannedResultForProduct("");
  };

  //============================ SCAN MODE =================================
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus(); // Focus the input field
    }
  }, [inputMode]);

  useEffect(() => {
    if (inputMode === "scan" && ScannedResultForProduct) {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
      debounceTimer.current = setTimeout(() => {
        if (
          ScannedResultForProduct &&
          !RSN.split("\n").includes(ScannedResultForProduct)
        ) {
          setRSN((prevRSN) => prevRSN + "\n");
        }
        FetchProductData(ScannedResultForProduct);
        setScannedResultForProduct("");
      }, 50);
      return () => {
        if (debounceTimer.current) {
          clearTimeout(debounceTimer.current);
        }
      };
    }
  }, [ScannedResultForProduct, shipRandomrsn.getparentrsn, inputMode]);

  const handleManualSubmit = () => {
    if (inputMode === "manual" && ScannedResultForProduct) {
      FetchProductData(ScannedResultForProduct);
      logAction(`${ScannedResultForProduct} is Inserted In The RSN Box`);
      if (
        ScannedResultForProduct &&
        !RSN.split("\n").includes(ScannedResultForProduct)
      ) {
        setRSN((prevRSN) => prevRSN + "\n");
        setScannedResultForProduct("");
        setTimeout(() => {
          if (inputRef.current) {
            inputRef.current.focus();
          }
        }, 0); // Ensure focus after state update
      }
    } else if (!ScannedResultForProduct || ScannedResultForProduct.trim() === "")  {
             toast.warning("Please Enter RSN");
  }
  };
  //============================ SCAN MODE TILL HERE =================================

  // =============== DATA FOR TABLE AND INPUT FIELDS ===============

  useEffect(() => {
    const handleShipmentChange = async (e) => {
      try {
        const res = await fetch(
          `${config.API_URL}/ShipmentInward_ForInput_Product_wise/${SHPH_ShipmentID}`,
          {
            method: "GET",
          }
        );
        if (res.ok) {
          const data = await res.json();
          if (data.shipmentData && data.shipmentData.length > 0) {
            setShipmentDetails(data.shipmentData[0]);
          } else {
            console.log("No shipment data found");
          }
        } else {
          console.log("Error retrieving shipment details");
        }
      } catch (error) {
        console.error("Failed to fetch shipment details:", error);
      }
    };
    handleShipmentChange();
  }, [SHPH_ShipmentID, selectedScpId]);

 //----------------------------------------------------------
 useEffect(() => {
  const fetchAllProductShipment = async () => {
    try {
      // 🔹 Step 1: Shipment Data
      const shipmentResponse = await axios.get(
        `${config.API_URL}/ShipmentInward_DataForTable_Product_Wise/${SHPH_ShipmentID}`
      );
      const shipmentData = shipmentResponse.data.shipmentData;

      if (shipmentResponse.status === 200 && shipmentData.length > 0) {
        // Aggregate by product code
        const aggregatedShipmentData = shipmentData.reduce((acc, shipmentItem) => {
          const existingItem = acc.find(
            (item) => item.SHPD_ProductCode === shipmentItem.SHPD_ProductCode
          );
          if (existingItem) {
            existingItem.SHPD_ScanQty += shipmentItem.SHPD_ScanQty;
            existingItem.SHPD_ShipQty += shipmentItem.SHPD_ShipQty;
          } else {
            acc.push({ ...shipmentItem });
          }
          return acc;
        }, []);

        // 🔹 Step 2: RSN Pack Size → update ReceivedQty
        const rsnResponse = await axios.get(
          `${config.API_URL}/Scanned_RSN_PackSize_OF_Shipment_Inward_Product_Wise/${SHPH_ShipmentID}`
        );
        const rsnData = rsnResponse.data.AllRSN_ToInward;

        let updatedShipmentData = [...aggregatedShipmentData];
        if (rsnResponse.status === 200 && rsnData.length > 0) {
          updatedShipmentData = aggregatedShipmentData.map((shipmentItem) => {
            const matchingRSN = rsnData.find(
              (rsnItem) => rsnItem.PL_ProductCode === shipmentItem.SHPD_ProductCode
            );
            return {
              ...shipmentItem,
              SHPD_ReceivedQty: matchingRSN
                ? shipmentItem.SHPD_ReceivedQty + matchingRSN.IRS_PackSize
                : shipmentItem.SHPD_ReceivedQty,
            };
          });
        } else {
          console.error("No RSN pack size data found.");
        }

        // 🔹 Step 3: Scanned RSNs
        const randomRSNResponse = await axios.get(
          `${config.API_URL}/Scanned_RSN_OF_Shipment_Inward_Product_Wise/${SHPH_ShipmentID}`
        );
        const randomRSNData = randomRSNResponse.data.AllRSN_ToInward;

        if (randomRSNResponse.status === 200 && randomRSNData.length > 0) {
          const scannedRSNs = randomRSNData.map((rsn) => rsn.IRS_RandomNo);

          // Update textarea RSN list
          setRSN(scannedRSNs.join("\n"));

          // 🔹 Step 4: Fetch RSN chain tree for each scanned RSN
          const rsnChainPromises = scannedRSNs.map((rsn) =>
            axios.get(`${config.API_URL}/RSNChainToMap/${rsn}`)
          );

          const rsnChainResponses = await Promise.allSettled(rsnChainPromises);

          const trees = rsnChainResponses
            .filter((res) => res.status === "fulfilled" && res.value.data.success)
            .map((res) => res.value.data.data);

          setRsnTree(trees); // Save all trees
          setTableData(updatedShipmentData);
        } else {
          console.error("No scanned RSN data found.");
          setTableData(updatedShipmentData);
        }
      } else {
        console.error("No shipment data found.");
      }
    } catch (error) {
      console.error("Failed to fetch shipment/RSN data:", error);
    }
  };

  fetchAllProductShipment();
}, [SHPH_ShipmentID, selectedScpId]);

 //----------------------------------------------------------
  
  // ==============================================================
const handleKeyDown = (e) => {
    if (!e.key.match(/^[\r\n\t]*$/)) {
      HandleScanChangeForProduct(e);
    }
  };


  const HandleInputChangeMenual = async (e) => {
    const scannedValue = e.target.value;
    setScannedResultForProduct(scannedValue);
    setShipRandomrsn({ getparentrsn: scannedValue });
    setFetchedData("");
  };


let scanTimeout;

  const HandleScanChangeForProduct = async (e) => {
    const scannedValue = e.target.value.trim();
    if (scanTimeout) clearTimeout(scanTimeout);

  scanTimeout = setTimeout(() => {
    // Match RSN: (21|00) followed by 8–25 alphanumeric characters until (01|10|17) or end
    const rsnMatch = scannedValue.match(/\((21|00)\)([A-Z0-9]{8,25})(?=\(01\)|\(10\)|\(17\)|$)/i);

    // Match GTIN: (01) followed by 8–25 digits
    const gtinMatch = scannedValue.match(/\(01\)(\d{8,25})/);

    let extractedRSN = "";
    let extractedGTIN = null;

    if (rsnMatch && /^[A-Z0-9]{8,25}$/.test(rsnMatch[2])) {
      extractedRSN = rsnMatch[2];
    } else if (/^[A-Z0-9]{8,25}$/i.test(scannedValue)) {
      extractedRSN = scannedValue;
    }

    if (gtinMatch && /^\d{8,25}$/.test(gtinMatch[1])) {
      extractedGTIN = gtinMatch[1];
    }
      if (extractedRSN) {
        setScannedResultForProduct(extractedRSN);
        setShipRandomrsn({ getparentrsn: extractedRSN });
        setFetchedData('');
        console.log(' Extracted RSN:', extractedRSN);
      } else {
        console.warn(' Invalid or corrupted RSN');
        setScannedResultForProduct('');
      }
if (extractedGTIN) {
      setExtractedGTIN(extractedGTIN);
      console.log("Extracted GTIN:", extractedGTIN);
    } else {
      setExtractedGTIN(null);
    }
 
    // Clear the input box after processing
    if (inputRef.current) inputRef.current.value = '';
  }, 50);
  };

  useEffect(() => {
    if (TableData & (TableData.length > 0)) {
      const FilteredData = TableData.filter(
        (shipment) => shipment.PL_ProductCode === TableData
      );
      setTableData((TableData) => [...TableData, ...FilteredData]);
    }
  }, [TableData]);

  // ==============================================================
const handleSelectAllChange = (e) => {
  if (e.target.checked) {
    let allItems = new Set();

    // ✅ Select all RSNs from textarea if valid
    if (typeof RSN === "string") {
      RSN.split("\n")
        .filter((line) => line.trim() !== "")
        .forEach((line) => allItems.add(line));
    }

    // ✅ Select all RSNs from rsnTree (root + children)
    const collectAllNodes = (node) => {
      allItems.add(node.IRS_RandomNo);
      if (node.children && node.children.length > 0) {
        node.children.forEach(collectAllNodes);
      }
    };
    if (rsnTree) {
      rsnTree.forEach(collectAllNodes);
    }

    setCheckedItems(allItems);
  } else {
    // ❌ Deselect all
    setCheckedItems(new Set());
  }
};



  const preventPaste = (e) => {
    e.preventDefault();
  };
  // Handle individual checkbox change
  const handleCheckBoxChange = (e, item) => {
    if (e.target.checked) {
      setCheckedItems((prevCheckedItems) => {
        const newCheckedItems = new Set(prevCheckedItems);
        newCheckedItems.add(item); // Add item when checked
        return newCheckedItems;
      });
      sessionStorage.removeItem("RSN");
      sessionStorage.removeItem("CheckedItems");
    } else {
      setCheckedItems((prevCheckedItems) => {
        const newCheckedItems = new Set(prevCheckedItems);
        newCheckedItems.delete(item); // Remove item when unchecked
        return newCheckedItems;
      });
      // Optional: Remove item from sessionStorage (if needed)
      sessionStorage.removeItem("RSN");
      sessionStorage.removeItem("CheckedItems");
    }
  };

  //=============================================
  const removeSelectedItemsAndUpdateStatus = async () => {
  try {
    // Trim and normalize selected items
    const selectedItems = Array.from(CheckedItems).map((it) =>
      String(it).trim()
    );

    if (selectedItems.length === 0) {
      toast.warn("Please select a minimum one serial number");
      logAction("Please select a minimum one serial number");
      return;
    }

    // Update backend status (inward)
    const response = await axios.put(
      `${config.API_URL}/Update_Removed_RSN_Status_Inward`,
      { IRS_RandomNos: selectedItems }
    );

    if (response.status !== 200) {
      console.log("Failed to update IRS_Status for the selected items");
      return;
    }

    console.log(
      "IRS_Status updated successfully for the selected items",
      selectedItems
    );
    const { packSizes } = response.data || {};
    logAction(
      `IRS_Status updated successfully for the selected items ${selectedItems}`
    );

    // Update TableData received qty using returned packSizes (robust to missing data)
    const totalPackSizeByProduct = (packSizes || []).reduce((acc, packSize) => {
      const { PL_ProductCode, IRS_PackSize } = packSize;
      acc[PL_ProductCode] = (acc[PL_ProductCode] || 0) + (Number(IRS_PackSize) || 0);
      return acc;
    }, {});

    const updatedShipments = TableData.map((shipment) => {
      const totalPackSize =
        totalPackSizeByProduct[shipment.SHPD_ProductCode] || 0;
      return {
        ...shipment,
        SHPD_ReceivedQty: Math.max(
          0,
          (shipment.SHPD_ReceivedQty || 0) - totalPackSize
        ),
      };
    });
    setTableData(updatedShipments);

    // Release / lock child RSNs (same as you used)
    const lockResponse = await axios.post(
      `${config.API_URL}/ChildRSN_Lock_Releas_Remove`,
      { IRS_ParentRandomNos: selectedItems }
    );

    if (lockResponse.status !== 200) {
      console.log("Failed to lock Child RSN for the selected items");
      return;
    }

    // --- Update textarea RSN (dedupe + trim) ---
    const selectedSet = new Set(selectedItems.map((s) => s.trim()));
    const remainingRSNArray = RSN.split("\n")
      .map((l) => l.trim())
      .filter((l) => l !== "" && !selectedSet.has(l));

    // dedupe remaining RSNs before setting (prevents showing duplicates)
    const remainingRSN = Array.from(new Set(remainingRSNArray)).join("\n");
    setRSN(remainingRSN);

    // --- Update rsnTree (recursive removal) ---
    setRsnTree((prevTree) => {
      if (!prevTree) return prevTree;

      const removeNodes = (node) => {
        // recurse over children first
        const children = (node.children || [])
          .map(removeNodes) // process grandchildren
          .filter(
            (child) =>
              !selectedSet.has(String(child.IRS_RandomNo).trim())
          ); // remove any child that was selected

        return {
          ...node,
          children,
        };
      };

      // map & clean each root, then remove roots that were selected
      const newTree = prevTree
        .map(removeNodes)
        .filter(
          (root) => !selectedSet.has(String(root.IRS_RandomNo).trim())
        );

      return newTree;
    });

    // --- Clear selections and extras ---
    setCheckedItems(new Set());
    selectedItems.forEach((item) => {
      if (UniqueRSN && UniqueRSN.has && UniqueRSN.has(item)) {
        UniqueRSN.delete(item);
      }
    });

    toast.success("Selected RSN removed successfully");

    // Reset Select All checkbox (UI)
    const selectAllCheckbox = document.getElementById("selectAll");
    if (selectAllCheckbox) selectAllCheckbox.checked = false;

    // Trigger any input UI refresh you had
    document.getElementById("RSNInput")?.dispatchEvent(new Event("input"));
  } catch (error) {
    console.error("Error updating IRS_Status:", error);
  }
};
 
const HandleAddRSNForBox = async (packSize, productCode, SelectedShipmentID) => {
  let updatedProductShipment = [...TableData];
  let found = false;

  if (ScannedResultForProduct && !UniqueRSN.has(ScannedResultForProduct)) {
    if (SelectedShipmentID) {
      for (let i = 0; i < updatedProductShipment.length; i++) {
        const shipment = updatedProductShipment[i];
        if (shipment.SHPD_ShipmentMID === SelectedShipmentID) {
          if (shipment.SHPD_ReceivedQty + packSize > shipment.SHPD_ScanQty) {
            toast.warning("Scanning limit reached");
            logAction(
              `Scan Quantity reached the limit please select another product or scan RSN of for another product `
            );
          } else {
            // Append scanned result
            // setRSN((prevContent) => prevContent + ScannedResultForProduct + "\n");
                    setRSN((prevContent) => {
  const updated = prevContent + ScannedResultForProduct + "\n";
  const uniqueLines = [...new Set(updated.split("\n").filter((l) => l.trim() !== ""))];
  return uniqueLines.join("\n");
});
            shipment.SHPD_ReceivedQty += packSize;
            setScannedResultForProduct("");
            setUniqueRSN(
              (prevSerials) => new Set(prevSerials.add(ScannedResultForProduct))
            );
            logAction(
              `RSN: ${ScannedResultForProduct} is Scanned For Shipment code: ${shipment.SHPH_ShipmentCode} Shipment ID: ${shipment.SHPH_ShipmentID} and Product ${shipment.SHPD_ProductName}`
            );
            found = true;
          }
          break;
        }
      }
    } else {
      for (let i = 0; i < updatedProductShipment.length; i++) {
        const shipment = updatedProductShipment[i];
        if (shipment.SHPD_ProductCode === productCode) {
          if (shipment.SHPD_ReceivedQty + packSize > shipment.SHPD_ScanQty) {
            toast.warning("Scanning limit reached");
            logAction(
              `Scan Quantity reached the limit please select another product or scan RSN of for another product `
            );
          } else {
            // Append scanned result
            // setRSN((prevContent) => prevContent + ScannedResultForProduct + "\n");
                    setRSN((prevContent) => {
  const updated = prevContent + ScannedResultForProduct + "\n";
  const uniqueLines = [...new Set(updated.split("\n").filter((l) => l.trim() !== ""))];
  return uniqueLines.join("\n");
});
            shipment.SHPD_ReceivedQty += packSize;
            setScannedResultForProduct("");
            setUniqueRSN(
              (prevSerials) => new Set(prevSerials.add(ScannedResultForProduct))
            );
            logAction(
              `RSN: ${ScannedResultForProduct} is Scanned For Shipment code: ${shipment.SHPH_ShipmentCode} Shipment ID: ${shipment.SHPH_ShipmentID} and Product ${shipment.SHPD_ProductName}`
            );
            found = true;
          }
          break;
        }
      }
    }

    if (found) {
      await fetchShipmentRSNLockForChild(SelectedShipmentID);
      await fetchShipmentRSNLockForParentRSN(SelectedShipmentID);

      // 🔥 Fetch RSN chain immediately for this new scanned RSN
      try {
        const resp = await axios.get(
          `${config.API_URL}/RSNChainToMap/${ScannedResultForProduct}`
        );
        const newChain = resp.data.data;

        setRsnTree((prevTree) => {
          if (!prevTree || prevTree.length === 0) return [newChain];

          // avoid duplicate root
          const exists = prevTree.some(
            (root) => root.IRS_RandomNo === newChain.IRS_RandomNo
          );
          return exists ? prevTree : [...prevTree, newChain];
        });
      } catch (err) {
        console.error("Failed to fetch RSN chain for new RSN:", err);
      }
    } else {
      setNotAddedValues((prevValues) => [...prevValues, ScannedResultForProduct]);
      await updateScannedIRSStatus();
    }

    setTableData(updatedProductShipment);
  } else if (!ScannedResultForProduct) {
    console.log("Serial number cannot be empty.");
  } else {
    console.log("Serial number already exists.");
  }
};


  const updateScannedIRSStatus = async () => {
    try {
      const response = await axios.put(
        `${config.API_URL}/Re_Update_Scanned_IRS_Status_Inward/${ScannedResultForProduct}`
      );
      if (response.status === 200) {
        console.log(
          `IRS_Status updated successfully for value '${ScannedResultForProduct}'`
        );
      } else {
        console.log(
          `Failed to update IRS_Status for value '${ScannedResultForProduct}'`
        );
      }
    } catch (error) {
      console.error("Error updating IRS_Status:", error);
      console.log(
        `Failed to update IRS_Status for value '${ScannedResultForProduct}'`
      );
    }
  };

  const updateInvoiceNumber = async () => {
    const { dcl_InvoiceNumber } = shipmentDetails;
    if (!dcl_InvoiceNumber) {
      console.log("Invoice Number is required");
      return;
    }
    try {
      const response = await axios.put(
        `${config.API_URL}/Update_Invoice_Number_Inward/${SHPH_ShipmentID}`,
        {
          SHPH_InvoiceNumber: dcl_InvoiceNumber,
          dcl_scpto: selectedScpId,
        }
      );
      if (response.status === 200) {
        console.log("Invoice number updated successfully");
        logAction(`Invoice number updated successfully${dcl_InvoiceNumber}`);
      } else {
        console.log("Failed to update invoice number");
      }
    } catch (error) {
      console.error("Error updating invoice number:", error);
      console.log("Error updating invoice number");
    }
  };

  const updateScanQuantity = async (shipment) => {
    const {
      SHPD_ShipmentID,
      SHPD_ProductCode,
      SHPD_ReceivedQty,
      SHPH_ShipmentCode,
    } = shipment;
    const dcl_scpto = selectedScpId;
    try {
      const response = await axios.put(
        `${config.API_URL}/update_scanqty_Inward`,
        {
          SHPD_ShipmentID,
          SHPD_ProductCode,
          SHPD_ReceivedQty,
          dcl_scpto,
        }
      );
      if (response.status === 200) {
        console.log(
          `Scan quantity updated successfully for Shipment ID ${SHPD_ShipmentID}`
        );

        const { PL_ProductName, PL_ProductCode, SHPD_SCPCode } =
          response.data.updatedData;
        const updatedAvailableQty = SHPD_ReceivedQty;
        await addNewValuesForInventoryProductlist({
          PL_ProductName: PL_ProductName,
          PL_ProductCode: PL_ProductCode,
          PL_CompanyID: UM_CompanyID,
          PL_CompanyGrpID: UM_CompanyGrpID,
          inv_scpid: SHPD_SCPCode,
          inv_Companyid: UM_CompanyID,
          inv_CompanyGrpid: UM_CompanyGrpID,
          inv_availableqty: updatedAvailableQty, // Assuming SHPD_ReceivedQty should be used for inv_availableqty
        });
        await updateInvoiceNumber();
        // toast.success(`Shipment : ${SHPH_ShipmentCode} saved successfully`);
        toast.success(`Shipment : ${SHPH_ShipmentCode} saved successfully.`, {
          toastId: `shipment-${SHPD_ShipmentID}`,
      });
      } else {
        console.log(
          `Failed to update scan quantity for Shipment ID ${SHPD_ShipmentID}`
        );
      }
    } catch (error) {
      console.error(
        `Error updating scan quantity for Shipment ID ${SHPD_ShipmentID}:`,
        error
      );
      console.log(
        `Failed to update scan quantity for Shipment ID ${SHPD_ShipmentID}`
      );
    }
  };
  const addNewValuesForInventoryProductlist = async (data) => {
    try {
      const response = await axios.post(
        `${config.API_URL}/AddNew_Values_For_Inventory_Productlist`,
        data
      );
      console.log(response.data.message);
    } catch (error) {
      console.error(
        "There was an error adding the product and inventory!",
        error
      );
      console.log("Failed to add product and inventory");
    }
  };

const [saveCallCount, setSaveCallCount] = useState(0); // Initialize call count state

const handleSave = async () => {
  if (saveCallCount > 0) {
    console.log("handleSave function already called, ignoring subsequent calls.");
    return; // Disable further execution
  }

  setSaveCallCount((prevCount) => prevCount + 1);

  const unequalItems = TableData.filter(
    (shipment) => shipment.SHPD_ScanQty !== shipment.SHPD_ReceivedQty
  );

  if (unequalItems.length > 0) {
    showPopup(
      "Are you sure you want to complete the shipment without scanning?",
      async () => {
        setIsButtonDisabled(true); // Disable the button
        try {
          for (const shipment of TableData) {
            await updateScanQuantity(shipment);
          }
          await callInsertIRSInfoAPI();
          setTimeout(() => {
            navigate("/ShipInScanPendingList");
          }, 2000);
        } catch (error) {
          console.error("Error updating scan quantities:", error);
          setIsButtonDisabled(false); // Re-enable the button on error
          setSaveCallCount(0); // Reset the call count on error
        }
      }
    );
  } else {
    setIsButtonDisabled(true); // Disable the button
    try {
      for (const shipment of TableData) {
        await updateScanQuantity(shipment);
      }
      await callInsertIRSInfoAPI();
      setTimeout(() => {
        navigate("/ShipInScanPendingList");
      }, 2000);
    } catch (error) {
      console.error("Error updating scan quantities:", error);
      setIsButtonDisabled(false); // Re-enable the button on error
      setSaveCallCount(0); // Reset the call count on error
    }
  }
};

//===================================================
  const callInsertIRSInfoAPI = async () => {
  
 const textareaRSNs = Array.from(
    new Set(RSN.split("\n").filter((line) => line.trim() !== ""))
  );
  
  // Collect RSNs from rsnTree (including all children)
  const treeRSNs = [];
  const collectAllNodes = (node) => {
    treeRSNs.push(node.IRS_RandomNo);
    if (node.children && node.children.length > 0) {
      node.children.forEach(collectAllNodes);
    }
  };
  
  if (rsnTree) {
    rsnTree.forEach(collectAllNodes);
  }
  
  // Combine and deduplicate all RSNs
  const allRSNValues = Array.from(new Set([...textareaRSNs, ...treeRSNs]));
  
    if (allRSNValues.length === 0) {
      console.log("No RSNs available to insert.");
      return;
    }
    console.log("Calling IRS info API with RSNs:", allRSNValues);
    try {
      const response = await axios.post(
        `${config.API_URL}/All_RSN_History_Insertion_Inward`,
        {
          IRS_RandomNos: allRSNValues, // Send all RSNs to the API
        }
      );
      if (response.status === 200) {
        console.log(
          "Data successfully inserted into rsnhistoryinfo:",
          response.data
        );
      } else {
        console.log("Failed to insert IRS info:", response);
      }
    } catch (error) {
      console.error("Error inserting IRS info:", error);
      toast.error("Failed to insert IRS info");
    }
  };

  const fetchShipmentRSNLockForChild = async () => {
    try {
      const response = await axios.get(
        `${config.API_URL}/ShipmentData_For_RSN_Inward/${selectedScpId}/${SHPH_ShipmentID}`
      );
      const shipmentData = response.data.ShipmentForRSN;
      console.log("Shipment Data:", shipmentData);

      for (const item of shipmentData) {
        await axios.put(
          `${config.API_URL}/ChildRSNLockToShipMentID_Inward/${shipRandomrsn.getparentrsn}`,
          {
            IRS_PhysicalLocation: item.IRS_PhysicalLocation,
          }
        );
      }
    } catch (error) {
      console.error("Error fetching shipment data:", error);
    }
  };

  const fetchShipmentRSNLockForParentRSN = async () => {
    try {
      const response = await axios.get(
        `${config.API_URL}/ShipmentData_For_RSN_Inward/${selectedScpId}/${SHPH_ShipmentID}`
      );
      const shipmentData = response.data.ShipmentForRSN;
      console.log("Shipment Data:", shipmentData);

      for (const item of shipmentData) {
        await axios.put(
          `${config.API_URL}/ParentRSNLockToShipMentID_Inward/${shipRandomrsn.getparentrsn}`,
          {
            IRS_PhysicalLocation: item.IRS_PhysicalLocation,
          }
        );
      }
    } catch (error) {
      console.error("Error fetching shipment data:", error);
    }
  };

  const isSaveButtonVisible = () => {
    return TableData.every(
      (shipment) => shipment.SHPD_ScanQty === shipment.SHPD_ReceivedQty
    );
  };

  const handleInputChange = (e) => {
    setShipmentDetails({
      ...shipmentDetails,
      dcl_InvoiceNumber: e.target.value,
    });
  };

  return (
    <>
      {/* <Sto /> */}
      <ToastContainer
        style={{
          marginTop: "73px",
          fontSize: "14px",
          width: "40%",
        }}
      />
      <div className="main_container">
        <h4 className="formHeading">Product wise scanning</h4>
        <div className="row">
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Shipment Code</label>
              <input
                name="SHPH_ShipmentCode"
                className="form-input"
                value={shipmentDetails.SHPH_ShipmentCode}
                readOnly
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Shipment Date</label>
              <input
                name="SHPH_ShipmentDate"
                className="form-input"
                value={shipmentDetails.SHPH_ShipmentDate}
                readOnly
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Logistic Company Name</label>
              <input
                name="LGCM_Name"
                className="form-input"
                value={shipmentDetails.LGCM_Name}
                readOnly
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Vehicle Number</label>
              <input
                name="LGCVM_VehicleNumber"
                className="form-input"
                value={shipmentDetails.LGCVM_VehicleNumber}
                readOnly
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Invoice Number</label>
              <input
                name="dcl_InvoiceNumber"
                className="form-input"
                value={shipmentDetails.dcl_InvoiceNumber}
                onChange={handleInputChange}
                autoComplete="off"
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <div className="d-flex align-items-center">
                <label className="form-label" style={{ marginBottom: "-5px" }}>
                  RSN
                </label>
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    marginRight: "-25px",
                  }}
                >
                  <input
                    type="radio"
                    name="inputMode"
                    value="manual"
                    checked={inputMode === "manual"}
                    onChange={() => handleInputModeChange("manual")}
                    style={{
                      accentColor: "black",
                      marginRight: "-25px",
                    }}
                  />
                  <label style={{ margin: "0" }}>Manual</label>
                </div>
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    marginRight: "-25px",
                  }}
                >
                  <input
                    type="radio"
                    name="inputMode"
                    value="scan"
                    checked={inputMode === "scan"}
                    onChange={() => handleInputModeChange("scan")}
                    style={{
                      accentColor: "black",
                      marginRight: "-25px",
                    }}
                  />
                  <label style={{ margin: "0" }}>Scan</label>
                </div>
              </div>
              {/* Manual Input Field */}
              {inputMode === "manual" && (
                <div className="d-flex align-items-center mt-2">
                  <div
                    className="input-group"
                    style={{ flexGrow: 1, marginRight: "10px" }}
                  >
                    <input
                      type="text"
                      className="form-input"
                      placeholder="Enter RSN"
                      ref={inputRef} // Use the inputRef to reference this input element
                      value={ScannedResultForProduct || ""}
                      onChange={HandleInputChangeMenual}
                      // onPaste={preventPaste}
                      disabled={!manualInputEnabled} // Disabled until product is selected or manual input is enabled
                      style={{ width: "100%" }}
                    />
                  </div>
                  <button className="btn btn-dark" onClick={handleManualSubmit}>
                    SUBMIT
                  </button>
                </div>
              )}

              {inputMode === "scan" && (
                <div className="d-flex align-items-center mt-2">
                  <div
                    className="input-group"
                    style={{ flexGrow: 1, marginRight: "10px" }}
                  >
                    <input
                      type="text"
                      className="form-input"
                      placeholder="Scan RSN"
                      ref={inputRef}
                      // value={ScannedResultForProduct || ""}
                      defaultValue=""
                      onChange={HandleScanChangeForProduct}
                      onPaste={preventPaste}
                      onKeyDown={handleKeyDown} // Handle scanner input
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="tableScanContainer col-md-9">
            <table className="scantableClass">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th className="nav-tabs">Product Name</th>
                  <th className="nav-tabs">Product Code</th>
                  <th className="nav-tabs">Order Quantity</th>
                  <th className="nav-tabs">Shiped Quantity</th>
                  <th className="nav-tabs">Scanned Quantity</th>
                </tr>
              </thead>
              <tbody>
                {TableData.length > 0 ? (
                  TableData.map((item, index) => (
                    <tr
                      key={item.SHPD_ShipmentMID}
                      onClick={() =>
                        setSelectedShipmentID(item.SHPD_ShipmentMID)
                      }
                    >
                      <td>{index + 1}</td>
                      <td>{item.SHPD_ProductName}</td>
                      <td>{item.SHPD_ProductCode}</td>
                      <td>{item.SHPD_OrderQty}</td>
                      <td>{item.SHPD_ScanQty}</td>
                      <td>{item.SHPD_ReceivedQty}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7">No data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

<div className="col-md-3">
  <div className="scanContainer">
    <p className="scannedHeading">Scanned RSN List</p>
    <div>
      <input
        className="form-check-input"
        type="checkbox"
        id="selectAll"
        onChange={handleSelectAllChange}
      />
      <label className="form-check-label" htmlFor="selectAll">
        Select All
      </label>
    </div>

    {/* 👇 Put it here */}
    {(() => {
      const treeRoots = new Set(rsnTree?.map((n) => n.IRS_RandomNo) || []);
      return RSN.split("\n")
        .map((line) => line.trim())
        .filter((line) => line !== "" && !treeRoots.has(line)) // exclude duplicates
        .map((line, index) => (
          <div key={index}>
            
          </div>
        ));
    })()}

    {/* ✅ Tree view (always rendered) */}
    {rsnTree &&
      rsnTree.map((rootNode) =>
        renderRSNNode(rootNode, 0, rootNode.isRoot)
      )}
  </div>

  <div className="button-container mt-2">
    <button
      onClick={removeSelectedItemsAndUpdateStatus}
      className="scan_btn"
    >
      REMOVE SELECTED
    </button>
  </div>
</div>
          
        </div>
      </div>
      <div className="button-container">
        {isSaveButtonVisible() && (
          <button
            className="save_btn"
            onClick={handleSave}
            disabled={isButtonDisabled}
          >
            Save
          </button>
        )}

        {isPopupVisible && (
          <div className="popup-box">
            <div className="popup-content-Suspend">
              <h5 className="Suspend-Popup-Heading">:: User Confirmation ::</h5>
              <p className="Suspend-Popup-Text">{message}</p>
              <div>
                <button
                  className="button-Confirm-Popup"
                  onClick={handlePopupConfirm}
                >
                  YES
                </button>
                <button
                  className="button-Close-Popup"
                  onClick={handlePopupClose}
                >
                  NO
                </button>
              </div>
            </div>
          </div>
        )}

        <Link to={`/ShipInScanPendingList`} className="back_btn" type="button">
          BACK{" "}
        </Link>
      </div>
    </>
  );
}

export default ShipInScanByProduct;
